import type { ReactNode } from 'react'

export interface EmptyStateProps {
  icon?: ReactNode
  title: string
  body?: string
}

export function EmptyState({ icon, title, body }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center px-6 py-12 text-center">
      {icon ? (
        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-[#EEF2F7] text-[#94A3B8]">
          {icon}
        </div>
      ) : null}
      <div className="text-[13px] font-medium text-[#0F172A]">{title}</div>
      {body ? <div className="mt-1 max-w-[240px] text-[12px] leading-relaxed text-[#64748B]">{body}</div> : null}
    </div>
  )
}
